import ErrorState from "../../ui/ErrorState";
import SprPageFrame from "../../ui/SprPageFrame";

const TITLE = "This page isn't available";
const MESSAGE = "Please check that you opened the full link from your email or WhatsApp message.";

/** Any address on the SPR domain other than a report link (see `SprHostApp`). */
const SprNotFoundPage = () => (
  <SprPageFrame>
    <ErrorState title={TITLE} message={MESSAGE} />
  </SprPageFrame>
);

export default SprNotFoundPage;
